<div class="content-card-container box-shadow" [style.max-width]="maxWidth">
  <ng-content></ng-content>
</div>
